module.exports = require("deep-extend");